import React from "react";
import { Odd } from "../../../../../models/Odd_response_model.tsx";
import { formatNumber } from "../../../../../helpers/functions.tsx";
import { useBetContext } from "../../../../../context/ParlayBetContext.tsx";

export function SelectedOddSpecialParlay({
    o,
    onRequestBetsModal,
}: {
    o: Odd;
    onRequestBetsModal: Function;
    currentBet?: { id_selection?: string };
    isSpecial?: boolean;
    propsLive?: boolean;
}) {
    const { bets } = useBetContext();
    const isSelected = bets.some(b => b.id_selection === o.id);
    const inputId = `parlay-special-${o.id}`;

    const label = (
        <>
            {`${formatNumber(o.points, o.selection_line, "points")} ${formatNumber(o.price)}`}
        </>
    );

    return (
        <>
            <div className={`large-screen ${o.selection_line ?? ''}`}>
                <div className="future-container-name">
                    <label className="select-box">{label}</label>
                </div>
                <div className="input-container-bet">
                    <input
                        id={inputId}
                        type="checkbox"
                        className="checkboxParlay"
                        checked={isSelected}
                        onChange={(e) => {
                            onRequestBetsModal({ odd: o }, e.target.checked);
                        }}
                    />
                </div>
            </div>

            <label
                className={`small-screen ${isSelected ? 'selected' : ''} ${o.market_id === 'total' ? 'total-odd' : ''}`}
                htmlFor={inputId}
            >
                <span className="points" style={{ fontSize: "14px" }}>
                    {label}
                </span>
            </label>
        </>
    );
}
